if (!customElements.get('sticky-atc-panel')) {
  class K2StickyPurchase extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.section = this.closest('.cc-main-product');
      this.form = document.getElementById(this.dataset.formId);
      this.button = this.querySelector('[data-sticky-purchase]');
      this.variantLabel = this.querySelector('[data-sticky-variant]');
      this.mainButton = this.form?.querySelector('[name="add"]');
      if (!this.section || !this.form || !this.button || !this.mainButton) return;
      this.bound = true;
      this.sync = this.syncState.bind(this);
      this.onClick = this.purchase.bind(this);
      this.onScroll = this.updateVisibility.bind(this);
      this.onVariant = () => requestAnimationFrame(this.sync);
      this.button.addEventListener('click', this.onClick);
      this.section.addEventListener('change', this.onVariant);
      this.section.addEventListener('input', this.onVariant);
      this.section.addEventListener('on:variant:change', this.onVariant);
      this.onError = () => {
        this.syncState();
        const error = this.form.querySelector('.js-form-error');
        if (error && !error.hidden) {
          error.setAttribute('tabindex', '-1');
          error.scrollIntoView({ block: 'center', behavior: 'auto' });
          error.focus({ preventScroll: true });
        }
      };
      this.section.addEventListener('on:cart:error', this.onError);
      this.form.addEventListener('submit', this.onVariant);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.mainButton, { attributes: true, childList: true, subtree: true });
      this.syncState();
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(this.onScroll);
        this.visibilityObserver.observe(this.mainButton);
      }
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
      this.section?.removeEventListener('change', this.onVariant);
      this.section?.removeEventListener('input', this.onVariant);
      this.section?.removeEventListener('on:variant:change', this.onVariant);
      this.section?.removeEventListener('on:cart:error', this.onError);
      this.form?.removeEventListener('submit', this.onVariant);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.bound = false;
    }

    syncState() {
      const id = this.form.querySelector('[name="id"]');
      const mainText = this.mainButton.textContent.trim();
      const busy = this.mainButton.getAttribute('aria-disabled') === 'true' || this.mainButton.classList.contains('is-loading');
      const picker = this.section.querySelector('variant-picker');
      const variantMismatch = picker?.variant?.id != null && String(picker.variant.id) !== String(id?.value);
      const unresolved = !id?.value || variantMismatch || Boolean(picker && (picker.preSelection || picker.variant === false || picker.variant === null));
      this.syncVariantLabel(picker, id?.value, unresolved);
      this.button.textContent = unresolved && !busy ? this.dataset.chooseOptions : mainText;
      this.button.disabled = busy || this.mainButton.disabled && !unresolved;
      this.button.setAttribute('aria-busy', String(busy));
      this.button.dataset.action = unresolved ? 'choose' : 'add';
      const mainPrice = this.section.querySelector('.product-info .price');
      const stickyPrice = this.querySelector('.card__info .price');
      if (mainPrice && stickyPrice && mainPrice.innerHTML !== stickyPrice.innerHTML) {
        stickyPrice.innerHTML = mainPrice.innerHTML;
      }
    }

    syncVariantLabel(picker, variantId, unresolved) {
      if (!this.variantLabel) return;
      const variant = picker?.variant;
      let label = '';
      if (!unresolved && variant && String(variant.id) === String(variantId)) {
        const options = Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3];
        const values = options.filter((value) => typeof value === 'string').map((value) => value.trim()).filter(Boolean);
        if (values.length && values.every((value) => value.toLowerCase() !== 'default title')) {
          label = values.join(' / ');
        } else if (!values.length && typeof variant.title === 'string' && variant.title.trim().toLowerCase() !== 'default title') {
          label = variant.title.trim();
        }
      }
      this.variantLabel.textContent = label;
      this.variantLabel.hidden = !label;
    }

    purchase() {
      this.syncState();
      if (this.button.disabled) return;
      if (this.button.dataset.action === 'choose') {
        const picker = this.section.querySelector('variant-picker');
        const target = picker?.querySelector('input:not([type="hidden"]), select, button') || this.mainButton;
        picker?.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        target.focus({ preventScroll: true });
        return;
      }
      this.mainButton.click();
      requestAnimationFrame(this.sync);
    }

    updateVisibility() {
      if (!this.mainButton) return;
      this.classList.toggle('sticky-atc-panel--out', this.mainButton.getBoundingClientRect().bottom > 0);
      document.body.classList.toggle('scrolled-to-bottom', window.scrollY + window.innerHeight + 100 > document.body.scrollHeight);
    }
  }
  customElements.define('sticky-atc-panel', K2StickyPurchase);
}
